import React from "react";

function CommonSearch({ placeholder, search, setSearch, maxWidth = '100%' }) {
    return (
        <div style={{ position: 'relative', minwidth: '350px', maxWidth, margin: '10px' }}>
            <svg
                style={{
                    position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
                    width: '25px', height: '16px', fill: '#0c4c63ff'
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
            >
                <path d="M21 20l-5.6-5.6a7 7 0 1 0-1.4 1.4L20 21zM10 16a6 6 0 1 1 0-12 6 6 0 0 1 0 12z" />
            </svg>
            <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={placeholder || "Search..."}
                style={styles.input}
            />
        </div>

    );
}

const styles = {
    input: {
        padding: '0px 0px 0px 30px',
        width: "100%",
        fontSize: "16px",
        outline: 'none',
        boxSizing: 'border-box',
    },
};

export default CommonSearch;
